// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__IEpH_","indented":"style_indented__NDe3z","shown":"style_shown__xzjOw","hidden":"style_hidden__F1zhT","no-padding":"style_no-padding__Nm4hY"};